//import Logo from "../../assets/logo.png";
export default function ProductCard() {
  return (
    <div className="bg-white rounded shadow-sm p-3 d-flex gap-3 align-items-start">
      <div style={{ width: "64px", height: "64px", flexShrink: 0 }}>
        {/* <Logo style={{ width: "100%", height: "100%" }} /> */}
      </div>
      <div>
        <h3 className="fw-medium h6 mb-1">Nom</h3>
        <p className="small text-muted mb-1">Marque:</p>
        <p className="small mb-0">pièce vendue</p>
      </div>
    </div>
  );
}
